module.exports = __webpack_public_path__ + "static/media/icon-close-agenda-x1.d60fd998.svg";